import { checkAuthAdminLifeTime } from "@/helpers/authenticate";

export default async function adminLogin({ to, next }) {
  if (checkAuthAdminLifeTime()) next({ name: "OffersSearch" });
  else next();
}
